import { useEffect, useState, useRef } from "react"
import { renderHoursChanel } from "utils/time"
import Loading from "components/ui/Loading"
import classNames from "classnames"
import { notification } from "components/ui"
import { apiFirebase } from "api"
import { fetchToken } from "lib/firebase"
import { getSessionId } from "utils/helper"

function convertEvent(obj, isCatchup) {
  return {
    ...obj,
    thumbnail: obj?.image,
    url: obj?.is_live ? obj?.channel?.url : obj?.catch_up_link,
    is_protected: obj?.channel?.is_protected,
    name: obj?.title,
    start_time: obj?.start,
    posterUrl: obj?.image,
    content_id: obj?.channel?.content_id,
    league_id: obj?.channel?.league_id,
    type: obj?.channel?.type,
    is_catchup: isCatchup
  }
}

export default function BoxRelatedTo({ list, onChangePlay, event_id, onDateChange }) {
  const [loading, setLoading] = useState(false)
  const [height, setHeight] = useState(400)
  const [selected, setSelected] = useState()
  const [currentDate, setCurrentDate] = useState(new Date())
  const __time = useRef()
  const wapper = useRef()
  const containerRef = useRef()
  const __tokenFirebase = useRef()
  const retryLoadToken = useRef(0)

  function onPlay(v, isPreview, isPartTime, isCatchup) {
    if (isPreview || v.is_live) {
      onChangePlay(convertEvent(v, isCatchup))
      setSelected(v.id)
    } else {
      if (isPartTime) notification.warning({ message: "Nội dung không hỗ trợ phát lại" })
    }
  }

  const handlePermission = async () => {
    const permission = await Notification.requestPermission()
    if (permission === "granted") {
      __tokenFirebase.current = await fetchToken()
    } else {
      // Handle permission denied
      notification.warning({ message: "Vui lòng bấm vào cho phép thông báo để nhận thông báo mới nhất" })
    }

    if (!__tokenFirebase.current && retryLoadToken.current < 3) {
      retryLoadToken.current += 1
      handlePermission()
    }
  }

  useEffect(() => {
    handlePermission()
  }, [])

  async function handleNotificationToggle(e, item) {
    e.stopPropagation()
    try {
      const body = {
        programme_id: item.programme_id,
        notify: item.is_subnoti ? "false" : "true",
        type: item.type || 0,
        event_id: event_id,
        synopsis: item.synopsis || ""
      }
      const sessionID = getSessionId()
      await apiFirebase.subNotiChannel(body, __tokenFirebase.current, sessionID)
      notification.success({ message: item.is_subnoti ? "Đã tắt thông báo" : "Đã bật thông báo" })
      // Refetch broadcast schedule to update UI
      if (onDateChange) {
        const dateStr = currentDate.toISOString().split("T")[0]
        onDateChange(dateStr)
      }
    } catch (error) {
      console.log(error)
      notification.error({ message: "Có lỗi xảy ra, vui lòng thử lại" })
    }
  }

  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  function changeDate(days) {
    const newDate = new Date(currentDate)
    newDate.setDate(newDate.getDate() + days)
    setCurrentDate(newDate)
    if (onDateChange) {
      const dateStr = newDate.toISOString().split("T")[0]
      onDateChange(dateStr)
    }
  }

  // useEffect(() => {
  //   const el = document.getElementById("container")
  //   if (el) setHeight(el.offsetHeight)
  //   function setH() {
  //     setHeight(el.offsetHeight)
  //   }
  //   window.addEventListener("resize", setH)
  //   return () => {
  //     clearTimeout(__time.current)
  //     window.removeEventListener("resize", setH)
  //   }
  // }, [])

  useEffect(() => {
    function setH() {
      const el = containerRef.current
      if (el) {
        const newHeight = el.offsetHeight
        if (newHeight > 0) {
          setHeight(newHeight)
        }
      }
    }

    // Set height immediately
    setH()

    // Also set height after a short delay to ensure DOM is fully rendered
    const timer = setTimeout(setH, 100)

    window.addEventListener("resize", setH)
    return () => {
      clearTimeout(timer)
      clearTimeout(__time.current)
      window.removeEventListener("resize", setH)
    }
  }, [])

  useEffect(() => {
    // Reset selection when event_id changes
    setSelected(null)
  }, [event_id])

  useEffect(() => {
    // Auto select and scroll to live program when list is loaded
    if (list?.length > 0 && !selected) {
      const timer = setTimeout(() => {
        const liveItem = list.find((item) => item.is_live)
        if (liveItem) {
          // Set selected state
          setSelected(liveItem.id)

          // Auto play live item
          onChangePlay(convertEvent(liveItem, false))

          // Scroll to live item
          const element = document.getElementById(`item-${liveItem.id}`)
          if (element && wapper.current) {
            const container = wapper.current
            const elementTop = element.offsetTop
            const containerHeight = container.offsetHeight
            const elementHeight = element.offsetHeight
            const scrollPosition = elementTop - containerHeight / 2 + elementHeight / 2

            container.scrollTo({
              top: scrollPosition,
              behavior: "smooth"
            })
          }
        }
      }, 200)

      return () => clearTimeout(timer)
    }
  }, [list, selected])

  return (
    <div ref={containerRef} className="rounded relative bg-[#131313] p-4 overflow-hidden h-full ml-0 min-h-[425px]">
      <Loading loading={loading}>
        <div className="flex justify-between items-center mb-2">
          <div className="text-lg font-semibold text-white">Lịch phát sóng</div>
        </div>

        <div
          className="flex items-center gap-2 justify-between px-[35px] rounded-xl my-2"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.04)"
          }}
        >
          <button className="p-2 hover:bg-white/10 rounded" onClick={() => changeDate(-1)}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8L8 12L12 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="text-white text-sm">{formatDate(currentDate)}</div>
          <button className="p-2 hover:bg-white/10 rounded" onClick={() => changeDate(1)}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 8L12 12L8 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="overflow-auto scroll__video space-y-2" style={{ height: height - 100 }} ref={wapper}>
          {list?.length > 0 ? (
            list?.map((item) => {
              const { title, id, start, end, is_live, catch_up_link, is_catchup, is_notification } = item
              const isPartTime = checkTimeNow(start)
              const isPreview = !is_live && isPartTime && (catch_up_link || is_catchup)
              const isSelected = id === selected
              const isUpcoming = !is_live && !isPartTime

              return (
                <div
                  id={`item-${id}`}
                  className={classNames("rounded-xl p-3 transition-all cursor-pointer", {
                    "bg-blue-600/20 border-2 border-blue-500": isSelected,
                    " hover:bg-[#333333]": !isSelected,
                    "opacity-50": !isPartTime && !is_live
                  })}
                  key={id}
                  onClick={() => onPlay(item, isPreview, isPartTime, is_catchup)}
                >
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                      {is_live ? (
                        <div className="flex items-center gap-2 w-16">
                          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                          <span className="text-base font-bold uppercase">LIVE</span>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 w-16">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                          <span
                            className={classNames("text-base font-bold ", {
                              "text-white": isPartTime,
                              "text-gray-500": !isPartTime
                            })}
                          >
                            {renderHoursChanel(start)}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="flex-grow">
                      <div
                        className={classNames("text-sm", {
                          "text-white": isPartTime || is_live,
                          "text-gray-500": !isPartTime && !is_live
                        })}
                      >
                        {title}
                      </div>
                      {is_live && (
                        <div className="flex items-center gap-2 mt-2">
                          <span className="text-xs text-gray-400">{renderHoursChanel(start)}</span>
                          <div className="flex-grow h-[2px] bg-gray-600 rounded-full overflow-hidden">
                            <div
                              className="h-full bg-gradient-to-r from-[#1363CC] to-[#1363CC] transition-all duration-1000"
                              style={{
                                width: `${calculateProgress(start, end)}%`
                              }}
                            ></div>
                          </div>
                          <span className="text-xs text-gray-400">{renderHoursChanel(end)}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center justify-center min-w-[30px]">
                      {isPreview && <button className="p-1 hover:bg-white/10 rounded">{iconPlay}</button>}
                      {isUpcoming && (
                        <button
                          className="p-1 hover:bg-white/10 rounded"
                          onClick={(e) => handleNotificationToggle(e, item)}
                        >
                          {is_notification ? iconNotificationActive : iconNotification}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="text-sm text-gray-400 text-center mt-10">Lịch phát sóng đang được cập nhật</div>
          )}
        </div>
      </Loading>
    </div>
  )
}

function checkTimeNow(start) {
  let endDate = new Date()
  let startDate = new Date(start)
  return endDate.getTime() - startDate.getTime() > 0 ? true : false
}

function calculateProgress(start, end) {
  const now = new Date().getTime()
  const startTime = new Date(start).getTime()
  const endTime = new Date(end).getTime()

  if (now < startTime) return 0
  if (now > endTime) return 100

  const totalDuration = endTime - startTime
  const elapsed = now - startTime
  const progress = (elapsed / totalDuration) * 100

  return Math.min(Math.max(progress, 0), 100)
}

const iconPlay = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.3712 0.0250652C11.7759 -0.321589 15.6276 2.96807 15.9742 7.37273C16.3209 11.7774 13.0312 15.6291 8.62654 15.9757C4.22189 16.3224 0.370186 13.0327 0.0235316 8.62808C0.00122255 8.34461 -0.0050511 8.04005 0.0039751 7.73892C0.0163855 7.3249 0.362082 6.99932 0.77611 7.01173C1.19014 7.02414 1.51571 7.36984 1.5033 7.78387C1.49585 8.03246 1.50101 8.28298 1.51891 8.51039C1.80056 12.0892 4.93007 14.762 8.50885 14.4804C12.0876 14.1987 14.7605 11.0692 14.4788 7.49042C14.1972 3.91164 11.0677 1.23878 7.48889 1.52044C5.75261 1.65709 4.18316 2.4709 3.07654 3.75512L2.873 4.003L5.2518 4.00387L5.35357 4.01072C5.71964 4.06038 6.0018 4.37417 6.0018 4.75387C6.0018 5.13356 5.71964 5.44736 5.35357 5.49702L5.2518 5.50387H1.25186L1.15009 5.49702C0.817293 5.45187 0.553854 5.18844 0.508706 4.85564L0.501859 4.75387V0.753869L0.508706 0.652098C0.553854 0.319302 0.817293 0.055863 1.15009 0.0107153L1.25186 0.00386864L1.35363 0.0107153C1.68643 0.055863 1.94987 0.319302 1.99501 0.652098L2.00186 0.753869L2.00066 2.70662C3.35856 1.16672 5.26656 0.190704 7.3712 0.0250652Z"
      fill="#FAFAF9"
    />
  </svg>
)

const iconNotification = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.5945 12.5681C16.536 12.4976 16.4785 12.4271 16.4221 12.3591C15.6468 11.4212 15.1777 10.8552 15.1777 8.20023C15.1777 6.8257 14.8488 5.69788 14.2007 4.85201C13.7228 4.22713 13.0767 3.75309 12.2252 3.40276C12.2143 3.39667 12.2045 3.38867 12.1963 3.37915C11.8901 2.35354 11.052 1.66663 10.1067 1.66663C9.16144 1.66663 8.32368 2.35354 8.01741 3.37809C8.00924 3.38726 7.99959 3.39501 7.98886 3.401C6.00179 4.21902 5.03609 5.78845 5.03609 8.19917C5.03609 10.8552 4.56769 11.4212 3.79161 12.358C3.73522 12.426 3.67777 12.4951 3.61927 12.567C3.46814 12.7493 3.37239 12.971 3.34334 13.206C3.3143 13.4409 3.35318 13.6793 3.45538 13.8929C3.67284 14.3511 4.1363 14.6355 4.66532 14.6355H15.552C16.0785 14.6355 16.5388 14.3514 16.757 13.8954C16.8596 13.6817 16.8988 13.4432 16.87 13.2079C16.8413 12.9727 16.7456 12.7506 16.5945 12.5681Z"
      stroke="white"
      strokeWidth="1.4"
    />
    <path
      d="M11.5521 17.9339C11.115 18.1953 10.6153 18.3335 10.106 18.3339C9.5968 18.3335 9.09719 18.1952 8.66018 17.9338C8.22316 17.6724 7.86504 17.2976 7.62378 16.8491C7.6124 16.8276 7.60678 16.8035 7.60748 16.7791C7.60818 16.7548 7.61517 16.7311 7.62777 16.7102C7.64037 16.6894 7.65814 16.6722 7.67937 16.6603C7.7006 16.6483 7.72455 16.6421 7.74889 16.6422H10.1064H12.4639C12.4882 16.6422 12.5121 16.6485 12.5333 16.6604C12.5545 16.6723 12.5722 16.6896 12.5848 16.7104C12.5973 16.7312 12.6043 16.7549 12.6049 16.7792C12.6056 16.8035 12.6 16.8276 12.5886 16.8491C12.3474 17.2976 11.9892 17.6724 11.5521 17.9339Z"
      fill="#FAFAF9"
    />
  </svg>
)

const iconNotificationActive = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.5945 12.5682C16.536 12.4977 16.4785 12.4272 16.4221 12.3592C15.6468 11.4213 15.1777 10.8553 15.1777 8.20035C15.1777 6.82582 14.8488 5.698 14.2007 4.85213C13.7228 4.22725 13.0767 3.75321 12.2252 3.40289C12.2143 3.39679 12.2045 3.38879 12.1963 3.37927C11.8901 2.35366 11.052 1.66675 10.1067 1.66675C9.16144 1.66675 8.32368 2.35366 8.01741 3.37821C8.00924 3.38739 7.99959 3.39513 7.98886 3.40112C6.00179 4.21914 5.03609 5.78858 5.03609 8.19929C5.03609 10.8553 4.56769 11.4213 3.79161 12.3581C3.73522 12.4261 3.67777 12.4952 3.61927 12.5671C3.46814 12.7494 3.37239 12.9711 3.34334 13.2061C3.3143 13.4411 3.35318 13.6794 3.45538 13.893C3.67284 14.3512 4.1363 14.6356 4.66532 14.6356H15.552C16.0785 14.6356 16.5388 14.3515 16.757 13.8955C16.8596 13.6819 16.8988 13.4433 16.87 13.208C16.8413 12.9728 16.7456 12.7507 16.5945 12.5682Z"
      fill="#FAFAF9"
    />
    <path
      d="M11.5521 17.934C11.115 18.1954 10.6153 18.3337 10.106 18.3341C9.5968 18.3336 9.09719 18.1953 8.66018 17.9339C8.22316 17.6725 7.86504 17.2977 7.62378 16.8492C7.6124 16.8277 7.60678 16.8036 7.60748 16.7793C7.60818 16.7549 7.61517 16.7312 7.62777 16.7104C7.64037 16.6895 7.65814 16.6723 7.67937 16.6604C7.7006 16.6485 7.72455 16.6422 7.74889 16.6423H10.1064H12.4639C12.4882 16.6423 12.5121 16.6486 12.5333 16.6605C12.5545 16.6725 12.5722 16.6897 12.5848 16.7105C12.5973 16.7313 12.6043 16.755 12.6049 16.7794C12.6056 16.8037 12.6 16.8277 12.5886 16.8492C12.3474 17.2977 11.9892 17.6726 11.5521 17.934Z"
      fill="#FAFAF9"
    />
  </svg>
)
